<template>
  <div class="d-avatar overflow-hidden" :class="[avatarClasses]" :style="{'height': computedSize, 'width': computedSize}">
    <div v-if="imgSrc" class="d-avatar--image">
      <div class="bg-cover bg-center" style="padding-bottom:100%" :style="{'background-image': `url(${imgSrc})`}" />
    </div>
    <span v-else-if="text" class="d-avatar--text" :style="{'font-size': computedFontSize}">
      {{ initials }}
    </span>
    <span v-else class="d-avatar--text">
      <d-icon icon="user" color="current" :style="{'font-size': computedFontIconSize}" />
    </span>
  </div>
</template>

<script>
  export default {
    props: {
      /**
       * Background color, if text is showing. Use a pre-defined color (`primary-500`, etc)
       */
      color: {
        type: String,
        default: 'primary-500',
      },

      /**
       * Up to two initials will be pulled from the text
       */
      text: {
        type: String,
        default: '',
      },

      /**
       * Image to show. This will take priority over text.
       */
      imgSrc: {
        type: String,
        default: '',
      },

      /**
       * Image/Circle Size. Include px/em/rem. Defaults to px if a number.
       */
      size: {
        type: [String, Number],
        default: '32px',
        validator: (val) => Number.parseInt(val, 10) || ((val.indexOf('px') > -1 || val.indexOf('em') > -1 || val.indexOf('rem')) > -1),
      },

      /*
       * Removes the border-radius from the component
       */
      tile: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      avatarClasses() {
        return {
          [`d-avatar--${this.color}`]: true,
          'rounded-full': !this.tile,
        };
      },

      initials() {
        const words = this.text.split(' ');
        let initials = words[0].substring(0, 1).toUpperCase();

        if (words.length > 1) {
          initials += words[words.length - 1].substring(0, 1).toUpperCase();
        }
        return initials;
      },

      computedSize() {
        return this.convertToUnit(this.size);
      },

      computedFontSize() {
        const adjustedSize = this.size;
        if (!Number.parseInt(adjustedSize, 10)) return '14px';
        return `${Number.parseInt(adjustedSize, 10) / 2.25}px`;
      },

      computedFontIconSize() {
        const adjustedSize = this.size;
        if (!Number.parseInt(adjustedSize, 10)) return '14px';
        return `${Number.parseInt(adjustedSize, 10) / 2.75}px`;
      },
    },

    methods: {
      convertToUnit(str, unit = 'px') {
        if (str == null || str === '') {
          return undefined;
        } if (Number.isNaN(+str)) {
          return String(str);
        }
        return `${Number(str)}${unit}`;
      },
    },
  };
</script>